import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

  export const GetDriver = createAsyncThunk('appBookingValidation/GetDriverList', async (GetDriver) => {
            const response = await axios.post(' https://api.zasway.com:8443/Driver/GetDriverList', GetDriver, {mode:'cors'})
            return response.data
  })

  export const GetDriverWithSearch = createAsyncThunk('appBookingValidation/GetDriverListWithSearch', async (GetDriver) => {
            const response = await axios.post(' https://api.zasway.com:8443/Driver/GetDriverListWithSearch', GetDriver, {mode:'cors'})
            return response.data
  })

  export const getClientListFilterWithSearch = createAsyncThunk('appBookingValidation/getClientList', async (params) => {
    const response = await axios.post(' https://api.zasway.com:8443/Common/GetClientListWithSearch', params, {mode: 'cors'})
    return response.data
  })

  export const getVehicleType = createAsyncThunk('appBookingValidation/getVehicleType', async (params) => {
    const response = await axios.post(' https://api.zasway.com:8443/Common/GetVehicleTypeList', params, {mode: 'cors'})
    return response.data
  })

  export const getClientList = createAsyncThunk('appBookingValidation/getClientList', async (params) => {
    const response = await axios.post(' https://api.zasway.com:8443/Common/GetClientList', params, {mode: 'cors'})
    return response.data
  })

  export const getPassengerList = createAsyncThunk('appBookingValidation/getPassengerList', async (params) => {
    const response = await axios.post(' https://api.zasway.com:8443/Common/GetPassengerList', params, {mode: 'cors'})
    return response.data
  })

  export const getPassengerListFilterWithSearch = createAsyncThunk('appBookingValidation/getPassengerList', async (params) => {
    const response = await axios.post(' https://api.zasway.com:8443/Common/GetPassengerListWithSearch', params, {mode: 'cors'})
    return response.data
  })

  export const getPaymentMethodList = createAsyncThunk('appBookingValidation/getPaymentMethodList', async (params) => {
    const companyID = JSON.parse(localStorage.getItem('companyID')) || 0
    const response = await axios.post(' https://api.zasway.com:8443/Common/GetPaymentMethodList', params || { companyID })
    return response.data
  })

  export const getBreakdownList = createAsyncThunk('appBookingValidation/getbreakdownList', async () => {
    const response = await axios.post(' https://api.zasway.com:8443/Common/GetBreakDownPeriodList')
    return response.data
  })

  export const getReportsDataBookingsTotalsCall = createAsyncThunk('reports/getreportsdatabookingtotals', async (params) => {
     
    const response = await axios.post(' https://api.zasway.com:8443/Reports/GetReportsDataBookingsTotals', params, {mode:'cors'})
     
    return response.data
  })

  export const getReportsBookingData = createAsyncThunk('reports/getreportsdatabooking', async (params) => {
      
    const response = await axios.post(' https://api.zasway.com:8443/Reports/GetReportsDataBooking', params, {mode:'cors'})
       
    return {
         params,
         data: response.data
       }
 })

 export const getReportsClientData = createAsyncThunk('reports/getreportsdataclient', async (params) => {
   
  const response = await axios.post(' https://api.zasway.com:8443/Reports/GetReportsDataClient', params, {mode:'cors'})
   
  return {
       params,
       data: response.data
     }
})

export const getReportsDriverData = createAsyncThunk('Reports/GetReportsDataDriver', async (params) => {
   
  const response = await axios.post(' https://api.zasway.com:8443/Reports/GetReportsDataDriver', params, {mode:'cors'})
    
  return {
       params,
       data: response.data
     }
})

export const getReportsPassengerData = createAsyncThunk('Reports/GetReportsDataPassenger', async (params) => {
   
  const response = await axios.post(' https://api.zasway.com:8443/Reports/GetReportsDataPassenger', params, {mode:'cors'})
   
  return {
       params,
       data: response.data
     }
})

export const getReportsVehcileTypeData = createAsyncThunk('Reports/GetReportsDataVehicleType', async (params) => {
   
  const response = await axios.post(' https://api.zasway.com:8443/Reports/GetReportsDataVehicleType', params, {mode:'cors'})
   
  return {
       params,
       data: response.data
     }
})

export const getReportsDataCustomerCommission = createAsyncThunk('reports/getReportsDataCustomerCommission', async (params) => {
  const response = await axios.post(' https://api.zasway.com:8443/Reports/GetReportsDataCustomerCommission', params, { mode: 'cors' })
  return {
    params,
    data: response.data
  }
})

export const getReportsInvoicePeriodList = createAsyncThunk('reports/getReportsInvoicePeriodList', async (params) => {
  const response = await axios.post(' https://api.zasway.com:8443/Reports/GetReportsInvoicePeriodList', params, { mode: 'cors' })
  return response.data
})

export const getReportsDataCustomerCommissionPay = createAsyncThunk('reports/getReportsDataCustomerCommissionPay', async (params) => {
  const response = await axios.post(' https://api.zasway.com:8443/Reports/GetReportsDataCustomerCommissionPay', params, { mode: 'cors' })
  return {
    params,
    data: response.data
  }
})


  export const appBookingValidationSlice = createSlice({
    name: 'reports',
    initialState: {
      data: [],
      total: 1,
      params: {},
      allData: [],
      Validateparams:{},
      InValidateparams:{},
      ValidateData:[],
      InValidateData:[],
      FilterState: false,
      Loader : false
    },
    reducers: {},
    extraReducers: builder => {
      builder
      .addCase(getReportsPassengerData.pending, (state) => {
        state.Loader = true
      })
      .addCase(getReportsPassengerData.fulfilled, (state) => {
        state.Loader = false
      })
      .addCase(getReportsDataCustomerCommission.pending, (state) => {
        state.Loader = true
      })
      .addCase(getReportsDataCustomerCommission.fulfilled, (state) => {
        state.Loader = false
      })
      .addCase(getReportsDataCustomerCommission.rejected, (state) => {
        state.Loader = false
      })
      .addCase(getReportsDataCustomerCommissionPay.pending, (state) => {
        state.Loader = true
      })
      .addCase(getReportsDataCustomerCommissionPay.fulfilled, (state) => {
        state.Loader = false
      })
      .addCase(getReportsDataCustomerCommissionPay.rejected, (state) => {
        state.Loader = false
      })
     }
  })
  
  export default appBookingValidationSlice.reducer
